import { FC, useRef, useState } from 'react';
import { Tr } from '@utils';
import { CarModel } from '@services';
import { Box, IconButton, IconButtonProps, List, ListItem, Menu, Stack, Typography } from '@mui/material';
import { VehicleImage } from '@components/portal/common';
import { ShoppingCartIcon } from '@components/icons';
import ClearIcon from '@mui/icons-material/Clear';

export interface ISelectedModelsCartProps extends Omit<IconButtonProps, 'ref'> {
	models: CarModel[];
	onRemove?: (model: CarModel) => void;
}

export const SelectedModelsCart: FC<ISelectedModelsCartProps> = ({ models, sx, onRemove, ...props }) => {
	const anchorRef = useRef<HTMLButtonElement>(null);
	const [open, setOpen] = useState(false);

	return (
		<>
			<IconButton
				ref={anchorRef}
				{...props}
				sx={{ color: models.length ? 'primary.main' : 'common.black', ...sx }}
				onClick={() => setOpen(!open)}
			>
				<ShoppingCartIcon />
			</IconButton>

			<Menu
				anchorEl={anchorRef.current}
				open={open}
				onClose={() => setOpen(false)}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
				PaperProps={{ variant: 'outlined', elevation: 0 }}
				sx={{ '.MuiMenu-list': { padding: 0 } }}
			>
				<Box sx={{ display: 'flex', height: 200, minWidth: 450, borderRadius: 2 }}>
					{models.length ? (
						<List sx={{ width: 1.0, paddingX: 3, overflowY: 'auto' }}>
							{models.map((model, i) => {
								return (
									<ListItem
										key={`selectable-model-${model.id}-${i}`}
										secondaryAction={
											<IconButton edge="end" onClick={() => onRemove?.(model)}>
												<ClearIcon />
											</IconButton>
										}
										sx={{ paddingY: 2 }}
										divider
									>
										<Stack direction="row" alignItems="center" spacing={2}>
											<VehicleImage
												model={model}
												style={{ height: '100%', width: 'auto' }}
												containerProps={{ sx: { height: 48 } }}
											/>

											<Typography>{[model.brand, model.model].filter(Boolean).join(' ')}</Typography>
										</Stack>
									</ListItem>
								);
							})}
						</List>
					) : (
						<Stack direction="column" alignItems="center" justifyContent="center" sx={{ width: 1.0 }}>
							<Typography>
								<Tr.Portal path="conversion-list.vehicle-comparison.car-band-list-suggestions.no-vehicles-selected" />
							</Typography>
						</Stack>
					)}
				</Box>
			</Menu>
		</>
	);
};
